import { SentryMinimal } from '@bridebook/toolbox/src/sentry';
import { FacebookLogin } from '@capacitor-community/facebook-login';
import { Appsflyer } from '@ionic-native/appsflyer';
import { env } from '../../env';
import { getIsIOS } from '../../mobile-app/selectors';
import { getPreferences } from '../../mobile-app/utils/preferences-wrapper';
import { IApplicationState } from '../../types';
import { ITrackEventAction } from '../actions';
import { mapEventToFacebookEvent } from '../mappers/event-to-facebook-event';
import { trackingMappers } from '../tracking-mappers';
import { toPreferenceKey } from './filter-cordova-track-actions';

export const sendTrackingEvent = async ([action, state]: [
  ITrackEventAction<unknown>,
  IApplicationState,
]) => {
  const trackingMapper = trackingMappers[action.event];
  const [eventName, appsflyerProps] = trackingMapper(action, state);

  if (eventName) {
    debugLog('Appsflyer.logEvent has been called with:', eventName, appsflyerProps);
    Appsflyer.logEvent(eventName, appsflyerProps);
  }

  const isIos = getIsIOS(state);
  const facebookEventName = mapEventToFacebookEvent(action.event, isIos ? 'ios' : 'android');
  debugLog('FacebookLogin.logEvent has been called with:', { facebookEventName, FacebookLogin });
  if (facebookEventName) {
    FacebookLogin.logEvent({ eventName: facebookEventName })
      .then(() => {
        debugLog('FacebookLogin.logEvent has been called with:', facebookEventName);
      })
      .catch((error) => {
        debugLog('FacebookLogin.logEvent error:', error);
        SentryMinimal().captureMessage(`[FACEBOOK_TRACKING]`, error);
      });
  }

  if (action.fireOnce) {
    await getPreferences().set({
      key: toPreferenceKey(action),
      value: '1',
    });
  }
};

const debugLog = (...args: unknown[]) => {
  // For testing purposes allow to console log events with props for env other than prod
  if (!env.LIVE) {
    /* eslint-disable no-console */
    console.log(...args);
  }
};
